import { GameId } from '@common'
import cx from 'classnames'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

import SkeletonBombDud from '@/assets/images/skeleton-bomb-dud.png'
import Spike from '@/assets/images/spike.png'

import { Button } from '../../components/buttons/Button'
import { STORE_BG } from './_storeBase/constants'
import { StoreTypography } from './_storeBase/typography/StoreTypography'

import styles from './maintenance.module.scss'

export type Props = {
  gameId: GameId
  reason: 'no_products' | 'maintenance'
}

export function Maintenance({ gameId, reason }: Props) {
  const t = useTranslations()
  const title = reason === 'no_products' ? t('game_no_products_title') : t('maintenance_tit')
  const description = t('maintenance_txt')
  const cta = t('game_no_products_cta')

  const backgroundImage = STORE_BG(gameId)
  const backgroundStyle = gameId === 'brawlstars' ? styles.BrawlStars : null

  return (
    <div className={cx(styles.Container, backgroundStyle)} style={{ backgroundImage }}>
      <div className={styles.Wrapper}>
        <StoreTypography tag="h1" textSize="lg" style="outlined" className={styles.Title}>
          {title}
        </StoreTypography>
        <p className={styles.Description}>{description}</p>
        <MaintenanceImage gameId={gameId} />
        <Button additionalClasses={styles.Cta} onClick={() => window.location.reload()}>
          {cta}
        </Button>
      </div>
    </div>
  )
}

function MaintenanceImage(props: { gameId: GameId }) {
  switch (props.gameId) {
    case 'clashofclans':
    case 'clashroyale':
      return <Image src={SkeletonBombDud} alt="" width={300} height={300} />
    case 'brawlstars':
      return <Image src={Spike} alt="" width={300} height={300} />
    default:
      return null
  }
}
